import Loading from "components/elements/Loading/Loading";
import AutodeskSymbolSvg from "components/icons/autodesk-symbol.svg";
import { useAutodeskHubs } from "../lib/hooks/useAutodeskHubs";
import AutodeskBrowserRow from "../controls/AutodeskBrowserRow";
import AutodeskFilteredList from "../controls/AutodeskFilteredList";
import AutodeskRequestError from "../controls/AutodeskRequestError";
import { AutodeskImportStepProps } from "./AutodeskImportStepProps";

export default function AutodeskImportHubStep(p: AutodeskImportStepProps) {
  const { hubs, hasError, error, isLoading, mutate } = useAutodeskHubs(
    p.state.accountId,
  );

  if (isLoading) return <Loading />;
  if (hasError)
    return (
      <AutodeskRequestError
        error={error}
        workspaceId={p.workspaceId}
        onRetry={() => mutate()}
        onReconnected={p.onReconnected}
      />
    );

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-thin">
        Select a <span className="font-normal">hub</span>
      </h1>
      <AutodeskFilteredList
        items={hubs ?? []}
        placeholder="Search hubs"
        emptyText="No hubs"
        getKey={(hub) => hub.id}
        getName={(hub) => hub.name}
        renderItem={(hub) => (
          <AutodeskBrowserRow
            icon={<AutodeskSymbolSvg />}
            label={hub.name}
            isDisabled={!hub.region}
            note={hub.region ? undefined : "Unavailable"}
            onClick={() => p.dispatch({ type: "CHOOSE_HUB", hub })}
          />
        )}
      />
    </div>
  );
}
